<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-cycling`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M27 4a7 7 0 014.037 12.72l.306.082c-.99 3.577.343 7.343 3.21 9.535a9 9 0 11-3.69 2.08 13.023 13.023 0 01-3.79-10.418L27 18a7 7 0 01-6.284-3.912c-2.632.57-4.769 2.1-6.487 4.673a1 1 0 00.81 1.555c6.814.154 10.53 4.976 10.958 13.585a2 2 0 11-3.994.198c-.334-6.715-2.623-9.684-7.055-9.784a5 5 0 01-4.045-7.776c2.32-3.474 5.397-5.636 9.15-6.4A7 7 0 0127 4zM11 26a9 9 0 110 18 9 9 0 010-18zm24.028 4.404a5 5 0 11-.79.427c.164.081.33.159.497.233l.293-.66zM11 30a5 5 0 100 10 5 5 0 000-10zm13-19a3 3 0 116 0 3 3 0 01-6 0z"/></svg>
</template>
<script>

export default {
  name: 'IconCycling',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
